import { render, staticRenderFns } from "./OrderStatusBadge.vue?vue&type=template&id=3c5d4394&scoped=true&"
import script from "./OrderStatusBadge.vue?vue&type=script&lang=js&"
export * from "./OrderStatusBadge.vue?vue&type=script&lang=js&"
import style0 from "./OrderStatusBadge.vue?vue&type=style&index=0&id=3c5d4394&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5d4394",
  null
  
)

export default component.exports